interface InvalidDocumentNumbersConfig {
  invalidNipNumbers?: string[];
  invalidPeselNumbers?: string[];
}

let getConfig: () => InvalidDocumentNumbersConfig = () => ({})

export const registerInvalidDocumentNumbersConfig = (getCurrentConfig: () => InvalidDocumentNumbersConfig): void => {
  getConfig = getCurrentConfig
}

export const isInvalidNipNumber = (nip: string): boolean => getConfig().invalidNipNumbers?.includes(nip) ?? false

export const isInvalidPeselNumber = (pesel: string): boolean => getConfig().invalidPeselNumbers?.includes(pesel) ?? false